import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f465cb2")

_pushScopeId("data-v-2f465cb2")
const _hoisted_1 = {
  class: "leading-9",
  style: {"font-size":"20px"}
}
const _hoisted_2 = { class: "sr-only" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "h-2 w-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 8 8"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M1 1l6 6m0-6L1 7",
    "stroke-linecap": "round",
    "stroke-width": "1.5"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedLabels, (activeLabel) => {
      return (_openBlock(), _createBlock("span", {
        key: activeLabel,
        class: ['inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1', _ctx.fontSize, 'font-medium', 'bg-'+_ctx.selectedLabelColor+'-100', 'text-'+_ctx.selectedLabelColor+'-700 mr-3']
      }, [
        _createTextVNode(_toDisplayString(activeLabel.name) + " ", 1),
        _createVNode("button", {
          class: ['flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center',
			'text-'+_ctx.selectedLabelColor+'-400', 'hover:bg-'+_ctx.selectedLabelColor+'-200', 'hover:text-'+_ctx.selectedLabelColor+'-500', 'focus:bg-'+_ctx.selectedLabelColor+'-500', 'focus:outline-none focus:text-white'],
          type: "button",
          onClick: ($event: any) => (_ctx.deleteLabelButton(activeLabel))
        }, [
          _createVNode("span", _hoisted_2, "Remove " + _toDisplayString(activeLabel), 1),
          _hoisted_3
        ], 10, ["onClick"])
      ], 2))
    }), 128)),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
      return (_openBlock(), _createBlock("span", {
        key: label,
        class: ['inline-flex rounded-full items-center py-0.5 pl-2.5 pr-1', _ctx.fontSize, 'font-medium', 'bg-'+_ctx.labelColor+'-100', 'text-'+_ctx.labelColor+'-700 mr-3 cursor-pointer'],
        onClick: ($event: any) => (_ctx.selectLabel(label))
      }, _toDisplayString(label.name), 11, ["onClick"]))
    }), 128))
  ]))
})